"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRedeemInputs = void 0;
const react_1 = require("react");
const formatValue = (value) => value.replace(/[^a-z0-9]/gi, '').toUpperCase();
function useRedeemInputs(code, onCodeChange) {
    const inputs = (0, react_1.useRef)([]);
    const updateCode = (index, value) => {
        const newCode = [...code];
        newCode[index] = formatValue(value || '');
        onCodeChange(newCode);
    };
    const onChange = (index) => (event) => {
        const value = event.target.value.slice(0, 1);
        const input = inputs.current[index];
        updateCode(index, value);
        if (input.value.trim()) {
            if (index + 1 < inputs.current.length) {
                return inputs.current[index + 1].focus();
            }
            return input.blur();
        }
    };
    const onKeyDown = (index) => (event) => {
        const input = inputs.current[index];
        if (event.key !== 'Backspace' || input.value.trim() !== '') {
            return;
        }
        event.preventDefault();
        event.stopPropagation();
        const previousIndex = Math.max(index - 1, 0);
        inputs.current[previousIndex].focus();
        updateCode(previousIndex, '');
    };
    const onPaste = (event) => {
        var _a;
        event.preventDefault();
        const data = event.clipboardData.getData('text/plain');
        if (!data) {
            return;
        }
        const newCode = formatValue(data).split('').slice(0, code.length);
        const fullLengthCode = [...newCode];
        /**
         * If pasted string is less than code length, fill it with empty strings
         */
        fullLengthCode.splice(newCode.length, 0, ...new Array(code.length - newCode.length).fill(''));
        onCodeChange(fullLengthCode);
        inputs.current.forEach(input => input.blur());
        if (newCode.length < code.length) {
            /**
             * Focus on first empty input
             */
            (_a = inputs.current[newCode.length]) === null || _a === void 0 ? void 0 : _a.focus();
        }
    };
    const ref = (index) => (input) => {
        inputs.current[index] = input;
    };
    return {
        ref,
        onChange,
        onKeyDown,
        onPaste,
    };
}
exports.useRedeemInputs = useRedeemInputs;
